<template>
  <div>
    <base-info
      ref="baseInfo"
      v-model="form"
      v-loading="loading"
      :form-tax-rate="formTaxRate"
      @shippingChange="handleShippingChange"
    />
    <product-list
      ref="product"
      :rebate-amount="form.rebateAmount"
      :sales-type="form.salesType"
      :rebate="form.rebate"
      :contract-type="form.contractType"
      :form="form"
      @chooseAddress="
        val => {
          form.receiptAddressId = val.id;
        }
      "
      @change="handleShippingChange"
    />
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-button type="primary" :loading="loading" @click="submit(0)">
          发布合同
        </el-button>
        <el-button type="default" :loading="loading" @click="submit(1)">
          保存草稿
        </el-button>
      </div>
    </div>
  </div>
</template>
<script type="es6">

import baseInfo from './baseInfo';
import productList from '../internationalProductList';
import { getCalculateInterSettlementAmountV2 } from '@/API/international';
import axios, { saveOrderContractInfo, getContractDetailAllInfoByConNum, getContractProductInfoByContractId, getReceiptAddressByContractId } from '@/API';
import { buildIntlOrderPublishComplianceRequest, checkIntlExportCompliance } from '@/libs/exportCompliance';
export default {
  data () {
    return {
      form: {
        id: null
      },
      loading: false,
      rejectedLoading: false,
      formTaxRate: ''
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    baseInfo,
    productList
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.contractNum).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.$nextTick(() => {
            this.$refs.baseInfo.setInitData();
            this.initProduct();
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    initProduct () {
      this.productLoading = true;
      axios.all([
        getContractProductInfoByContractId(this.form.id),
        getReceiptAddressByContractId(this.form.id)
      ]).then((res) => {
        let fjson = res[0].data;
        let sjson = res[1].data;
        this.productLoading = false;
        if (fjson.status === '200') {
          this.$refs.product.productList = fjson.data;
        }
        if (sjson.status === '200') {
          this.$refs.product.address = sjson.data;
        }
      }).catch(() => {
        this.productLoading = false;
      });
    },
    handleShippingChange () {
      const baseInfo = this.$refs.baseInfo.form;

      const product = this.$refs.product;
      const productVOList = [];
      product.productList.forEach((item) => {
        productVOList.push({
          id: item.id,
          settlementAmount: item.settlementAmount,
          productCode: item.productCode,
          productPriceSigle: item.productPriceSigle,
          productNum: item.productNum
        });
      });
      const params = {
        contractId: baseInfo.id,
        modeOfShipping: baseInfo.modeOfShipping,
        isRebate: baseInfo.isRebate,
        rebateAmount: baseInfo.isRebate ? baseInfo.rebateAmount : 0,
        productVOList: productVOList,
        orderUnitName: baseInfo.orderUnit,
        salesType: baseInfo.salesType,
        supplyUnitId: baseInfo.supplyUnitId,
        overSeasSalesCountry: baseInfo.soldCountry,
        communicationOrderDiscount: baseInfo.communicationOrderDiscount
      };
      this.getCalculateInterSettlementAmountV2(params);
    },
    getCalculateInterSettlementAmountV2 (params) {
      const product = this.$refs.product;
      getCalculateInterSettlementAmountV2(params).then((res) => {
        const json = res.data;
        this.formTaxRate = json.data.formTaxRate;
        if (json.status === '200') {
          let _productList = product.productList;
          _productList.forEach((i) => {
            json.data.productVOList.forEach((j) => {
              // 产品单价、销售代码、数量一致
              if (i.productPriceSigle === j.productPriceSigle && i.productCode === j.productCode && i.productNum === j.productNum) {
                i.settlementAmount = j.settlementAmount;
              }
            });
          });
          // 运输方式是否有运费
          if (json.data.freightFlag) {
            let freightInfo = _productList.find(item => item.productName === 'Freight');
            // 产品行中是否有运费，有则更新，没有则添加
            if (freightInfo !== undefined) {
            // freightInfo = { ...json.data.freightProduct };
              this.$set(freightInfo, 'productPriceSigle', json.data.freightProduct.productPriceSigle);
              this.$set(freightInfo, 'settlementAmount', json.data.freightProduct.settlementAmount);
              this.$set(freightInfo, 'orderAmount', json.data.freightProduct.orderAmount);
              this.$set(freightInfo, 'beforeSplitProductPriceSigle', json.data.freightProduct.beforeSplitProductPriceSigle);
            } else {
              _productList.push(json.data.freightProduct);
            }
          } else {
            let freightInfoIndex = _productList.findIndex(item => item.productName === 'Freight');
            // 删除已存在的运费
            if (freightInfoIndex !== -1) {
              delete _productList.splice(freightInfoIndex, 1);
            }
          }
        }
      }).catch((res) => {

      });
    },
    async submit (val) {
      let baseR = true;
      let Product = {};
      if (!val) {
        baseR = await this.$refs.baseInfo.validate();
      } else {
        baseR = this.$refs.baseInfo.validatedrafts();
      }
      Product = await this.$refs.product.validate();
      if (baseR && Product) {
        val ? baseR.contractInfo.isDraft = true : baseR.contractInfo.isDraft = false;

        let contractDetail = {
          actualSettlementAmount: Product.actualSettlementAmount,
          orderSales: Product.orderSales,
          netSales: baseR.netSales,
          productServiceProviderA: this.form.productServiceProviderA,
          productServiceProviderB: this.form.productServiceProviderB,
          productServiceProviderC: this.form.productServiceProviderC,
          serviceSubjectName: this.form.serviceSubjectName
        };

        baseR.contractDetail = { ...baseR.contractDetail, ...contractDetail };

        if (!val) {
          this.loading = true;
          // 发布国际合同（草稿编辑）：提交前出口合规预检
          const decision = await checkIntlExportCompliance(this,
            buildIntlOrderPublishComplianceRequest(this.form, Product.productList));
          if (!decision.allowBusiness) {
            this.loading = false;
            return;
          }
        }

        this.loading = true;
        saveOrderContractInfo({ ...baseR, contractProductInfos: Product.productList }).then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === '200') {
            if (val) {
              this.$router.replace({ name: 'orderPersionDrafts' });
            } else {
              this.$router.replace({ name: 'orderPersionContractList' });
            }
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    }
  },
  mounted () {
    this.initData();
    this.isShowInternationalServiceOrders = Number(this.$route.query.isShowInternationalService);
  }
};
</script>
<style lang="scss" scoped></style>
